<template>
  <div class="profile">
    <div class="profile__nav">
      <ul class="profile__nav--ul">
        <router-link to="/profile">
          <font-awesome-icon icon="user" />
          <li class="profile__nav--ul-li">اطلاعات شخصی</li>
        </router-link>
        <router-link to="/profile/withdrawlist">
          <font-awesome-icon icon="user" />
          <li class="profile__nav--ul-li">برداشت های کیف پول</li>
        </router-link>
        <router-link to="/profile/withdraw">
          <font-awesome-icon icon="user" />
          <li class="profile__nav--ul-li">درخواست واریز</li>
        </router-link>
        <router-link to="/profile/address">
          <font-awesome-icon icon="user" />
          <li class="profile__nav--ul-li">آدرس ها</li>
        </router-link>
        <router-link to="/profile/pass-change">
          <font-awesome-icon icon="user" />
          <li class="profile__nav--ul-li">تغییر پسورد</li>
        </router-link>
        <router-link to="/profile/favlist">
          <font-awesome-icon icon="user" />
          <li class="profile__nav--ul-li">علاقه مندی ها</li>
        </router-link>
        <router-link to="/profile/myorder">
          <font-awesome-icon icon="user" />
          <li class="profile__nav--ul-li">سفارش های من</li>
        </router-link>

        <a href="" @click.prevent="exit">
          <font-awesome-icon icon="times-circle" />
          <li class="profile__nav--ul-li">خروج</li>
        </a>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  methods: {
    exit() {
      localStorage.removeItem("profile");
      localStorage.removeItem("name");
      localStorage.clear();
      this.$store.state.user.name = "";

      // this.$store.state.name = "ورود به حساب کاربری";
      // localStorage.setItem("name", null);
      // localStorage.setItem("profile", null);
      this.$store.state.islog = false;
      this.$store.state.co = 0;
      this.$toastr.s("شما از حساب کاربری خود خارج شدید");
      // location.reload();
      // this.$forceUpdate();
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss" scoped>
.profile {
  width: 100%;
  min-height: 10vh;
  margin-top: 7.9em;
  &__nav {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    width: 99%;
    z-index: 7;
    // background: red;
    font-size: 0.75em;
    @media screen and (max-width: 900px) {
      height: 40px;
      font-size: 0.5em;
    }
    @media screen and (max-width: 500px) {
      font-size: 0.35em;
      height: 40px;
      width: 100%;
    }
    &--ul {
      height: 100%;
      direction: rtl;
      border-start-start-radius: 25px;
      border-start-end-radius: 25px;
      // padding-right: 2em;
      @media screen and (max-width: 900px) {
        border-start-start-radius: 15px;
        border-start-end-radius: 15px;
      }
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.308);
      background: var(--main-color);
      display: flex;
      padding: 1em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-li {
        color: var(--font-color);
        display: flex;
        // background: red;
        // justify-content: center;
        &:hover {
          color: var(--sub-color);
        }
      }
      svg {
        color: var(--sub-color);
        margin-left: 0.5em;
      }
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/profile.vue